"use client";
import {useEffect} from "react";
import {useCookieCampusId} from "./contexts/CampusCookieContext";
import {useUserInfo} from "@/app/_components/contexts/userInfoContext";
import getUserData from "@/app/_components/EventTracker/getUserData";

/**
 * Utility component which attaches some variables to the window object for analytics tagging.
 *
 * @returns null
 */
const AnalyticsVariablesSetter = () => {
	const {userInfo, isLoading} = useUserInfo();
	const campusId = useCookieCampusId();
	useEffect(() => {
		// Make sure everything is loaded before rending component
		if (isLoading) {
			return;
		}

		// Load the user data and add it to the dataLayer
		window.analytics = getUserData(userInfo, campusId);
		window.dataLayer?.push(window.analytics);
	}, [userInfo, campusId, isLoading]);
	return null;
};

export default AnalyticsVariablesSetter;
